import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { ToggleButtonGroup } from "../components/widgets/toggle-button-group";
import { Root } from "@definitions";
import { ToggleButtonGroupNode } from "src/definitions/ui-definitions";

type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	ToggleButtonGroupNode
>;

export class ToggleButtonGroupComponentBuilder
	implements UiComponentBuilder<Root, ToggleButtonGroupNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(
		node: ToggleButtonGroupNode,
		context: UiComponentBuildContext<Root>,
	) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
					write
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node, context)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node, context);
		}
	}

	private _render(
		node: ToggleButtonGroupNode,
		_context: UiComponentBuildContext<Root>,
	): ReactElement {
		const { state, type, id, visible, ...props } = node;

		return <ToggleButtonGroup {...props} />;
	}
}
